<!-- search Public organization -->
<template>
  <div id="search">
    <div class="searchHeader">
      <div class="searchHeader_view1">
        <div class="text">{{ viewTitle }}</div>
        <div class="icon">
          <img src="../assets/images/icons/ShutDown.png" @click="closeView" />
        </div>
      </div>
      <div class="searchHeader_view2" v-if="viewName !== 'network'">
        <input
          type="text"
          :placeholder="$t('nav.search_components_placeHolder')"
          v-model="searchText"
        />
        <div class="searchIcon">
          <img
            src="https://alchemywalletdownload.oss-cn-hongkong.aliyuncs.com/alchemypay/crypto-images/searchIcon.svg"
          />
        </div>
      </div>
    </div>
    <div class="search_core">
      <!-- 法币 -->
      <lazy-component>
        <ul v-if="viewName === 'fiatCurrency'">
          <div v-if="searchText === ''">
            <li
              class="payCurrencyLi"
              v-for="(item, index) in allBasicData.fiatCurrencyList"
              :key="'fiatCurrency_' + index"
              @click="choiseItem('fiatCurrency', item)"
            >
              <p class="seach_li_text">
                <img :src="item.icon" :key="item.icon" v-lazy="item.icon" />
                <span class="allName">{{ item.code }} </span>
                <span style="margin-left: 0.05rem"> </span>
                <span class="abbreviationName"> {{ item.name }}</span>
              </p>
            </li>
          </div>
          <div v-else>
            <li
              class="payCurrencyLi"
              v-for="(item, index) in searchData"
              :key="'searchData' + index"
              @click="choiseItem('fiatCurrency', item)"
            >
              <p class="seach_li_text">
                <img :src="item.icon" :key="item.icon" v-lazy="item.icon" />
                <span class="allName">{{ item.code }} -</span>
                <span class="abbreviationName"> {{ item.name }}</span>
              </p>
            </li>
          </div>
        </ul>
      </lazy-component>
    </div>
  </div>
</template>

<script>
/**
 * 搜索、选择列表组件
 * viewName - 组件名称
 * allBasicData - 买卖币基本数据
 */

export default {
  name: "search",
  props: ["viewName", "allBasicData"],
  data() {
    return {
      viewTitle: "",

      //Search for data
      searchText: "",

      //all data(all / network)
      basicData: {},

      //国家法币上次交易数据
      recent_payCurrency: [],

      cryptoCurrency_recentList: [],
      //Recommended digital currency list
      popularList: [],
      //Support digital currency list
      cryptoCurrencyVOList: [],

      //国家法币
      countryLegalCurrency: [],
    };
  },
  computed: {
    //Fuzzy search
    // eslint-disable-next-line vue/return-in-computed-property
    searchData() {
      //搜索法币
      if (this.searchText && this.viewName === "fiatCurrency") {
        //brazil-country
        let resultArray_country1 = [],
          resultArray_country2 = [],
          resultArray_country3 = [],
          resultArray_country4 = [],
          all_resultArray_country = [],
          legalCurrency = []; //,legalCurrency = []
        //法币简称
        resultArray_country1 = this.allBasicData.fiatCurrencyList.filter(
          (value, index) => {
            if (value.code.includes(this.searchText)) {
              this.allBasicData.fiatCurrencyList[index].indexOfNum =
                value.code.indexOf(this.searchText);
              return value;
            }
          },
        );
        resultArray_country2 = this.allBasicData.fiatCurrencyList.filter(
          (value, index) => {
            if (
              value.code.includes(
                this.searchText.charAt(0).toUpperCase() +
                  this.searchText.slice(1),
              )
            ) {
              this.allBasicData.fiatCurrencyList[index].indexOfNum =
                value.code.indexOf(
                  this.searchText.charAt(0).toUpperCase() +
                    this.searchText.slice(1),
                );
              return value;
            }
          },
        );
        resultArray_country2 = this.allBasicData.fiatCurrencyList.filter(
          (value, index) => {
            if (
              value.code.includes(
                this.searchText.charAt(0).toUpperCase() +
                  this.searchText.slice(2),
              )
            ) {
              this.allBasicData.fiatCurrencyList[index].indexOfNum =
                value.code.indexOf(
                  this.searchText.charAt(0).toUpperCase() +
                    this.searchText.slice(2),
                );
              return value;
            }
          },
        );
        //法币全称
        // resultArray_country3 = this.allBasicData.fiatCurrencyList.filter((value,index) => {
        //   if(value.nftParamNo.includes(this.searchText) && value.nftParamNo){
        //     this.allBasicData.fiatCurrencyList[index].indexOfNum = value.nftParamNo.indexOf(this.searchText);
        //     return value;
        //   }
        // })
        // resultArray_country4 = this.allBasicData.fiatCurrencyList.filter((value,index) => {
        //   if(value.nftParamNo.includes(this.searchText.toUpperCase()) && value.nftParamNo){
        //     this.allBasicData.fiatCurrencyList[index].indexOfNum = value.nftParamNo.indexOf(this.searchText.toUpperCase());
        //     return value;
        //   }
        // })
        //完全匹配法币币种
        legalCurrency = this.allBasicData.fiatCurrencyList.filter(
          (value, index) => {
            if (this.searchText.toUpperCase() === value.code) {
              this.allBasicData.fiatCurrencyList[index].indexOfNum = 999;
              return value;
            }
          },
        );
        all_resultArray_country = all_resultArray_country
          .concat(resultArray_country4)
          .concat(resultArray_country3)
          .concat(resultArray_country2)
          .concat(resultArray_country1)
          .concat(legalCurrency); //.concat(legalCurrency)
        all_resultArray_country = [...new Set(all_resultArray_country)];
        all_resultArray_country.sort((a, b) => {
          return a.indexOfNum - b.indexOfNum;
        });
        return all_resultArray_country;
      }
    },
  },
  mounted() {
    this.customComponentTitle();
  },
  methods: {
    //搜索组件标题
    customComponentTitle() {
      //法币
      if (this.viewName === "fiatCurrency") {
        this.viewTitle = this.$t("homePage.selectCurrency");
      }
    },

    //关闭组件
    closeView() {
      //法币
      if (this.viewName === "fiatCurrency") {
        this.$parent.searchState = true;
      }
    },

    //Select data
    choiseItem(type, val) {
      setTimeout(() => {
        if (type === "fiatCurrency") {
          this.$nextTick(() => {
            this.$parent.$refs.NFT_ref.changeFiatCurrency(val);
          });
          this.$parent.searchState = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#search {
  z-index: 99;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_core {
    flex: 1;
    overflow: auto;
    .allCurrencyLi {
      margin-top: 0.16rem !important;
    }
    ul {
      height: 100%;
      .payCurrencyLi:first-child {
        margin-top: 0;
      }
      li {
        display: flex;
        align-items: center;
        margin-top: 0.24rem;
        cursor: pointer;
        .seach_li_text {
          font-size: 0.16rem;
          font-family: Semibold;
          font-weight: 600;
          color: #6e7687;
          display: flex;
          align-items: center;
          margin-left: 0.05rem;
          flex-wrap: nowrap;
          .seach_li_allText {
            font-family: Regular;
            font-weight: 400;
            margin-left: 0.04rem;
          }
          .allName {
            font-size: 0.16rem;
            font-family: Semibold;
            font-weight: 600;
            color: #6e7687;
          }
          .abbreviationName {
            font-family: Regular;
            font-weight: 400;
            margin-left: 0.03rem;
            color: #6e7687;
          }
          img {
            width: 0.36rem;
            height: 0.36rem;
            border-radius: 50%;
            margin-right: 0.08rem;
            background: #000000;
          }
        }
      }
      li:nth-of-type(1) {
        margin-top: 0.16rem;
      }
    }
  }
}
.searchHeader {
  padding-bottom: 0.24rem;
  .searchHeader_view1 {
    font-size: 0.21rem;
    font-family: Semibold;
    font-weight: 600;
    color: #232323;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.1rem 0 0 0.1rem;
    .text {
      font-size: 0.18rem;
      color: #031633;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.1rem;
      margin-left: auto;
      cursor: pointer;
      img {
        width: 0.22rem;
      }
    }
  }
  .searchHeader_view2 {
    width: 100%;
    height: 0.58rem;
    background: #f4f5f7;
    border-radius: 10px;
    display: flex;
    margin-top: 0.3rem;
    position: relative;
    border-radius: 0.29rem;
    overflow: hidden;
    input {
      width: 100%;
      height: 100%;
      font-size: 0.16rem;
      font-family: Regular;
      font-weight: 400;
      padding: 0 0.47rem;
      background: #f7f8fa;
      border-radius: 10px;
      outline: none;
      border: none;
      color: #6e7687;
      border: 1px solid #0059da;
      border-radius: 0.28rem;
    }
    input::placeholder {
      color: #bfbfbf;
    }
    .searchIcon {
      display: flex;
      position: absolute;
      left: 0.2rem;
      top: 0.21rem;
      img {
        width: 0.16rem;
      }
    }
  }
}
</style>
